// src/stores/useAuthStore.js
import { defineStore } from "pinia";
import Swal from "sweetalert2";
import AuthHelper from "@/helpers/auth-helper";
import api from "@/services/api";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    accessType: AuthHelper.getAccessType(),
    superAdmin: AuthHelper.getSuperAdmin(),
    activeOrganization: AuthHelper.getActiveOrganization(),
    availableOrganizations: [],
    loading: false,
  }),

  getters: {
    isSuperAdmin(state) {
      return state.accessType === "S";
    },
    isOrgAdmin(state) {
      return state.accessType === "A";
    },
    isUser(state) {
      return state.accessType === "U";
    },
  },

  actions: {
    loadFromStorage() {
      this.accessType = AuthHelper.getAccessType();
      this.superAdmin = AuthHelper.getSuperAdmin();
      this.activeOrganization = AuthHelper.getActiveOrganization();
    },

    async fetchAvailableOrganizations() {
      try {
        const res = await api.get("/available-organizations");
        if (res.data?.success) {
          this.availableOrganizations = res.data.data || [];
        }
      } catch (err) {
        console.error("Erreur chargement organisations:", err);
      }
    },

    async switchOrganization(orgId) {
      this.loading = true;
      try {
        const res = await api.post("/switch-organization", { organization: orgId });
        if (res.data?.success && res.data.data?.token) {
          AuthHelper.saveUserInfo({ token: res.data.data.token });
          this.loadFromStorage();
          return true;
        }
        return false;
      } catch (err) {
        this.handleError(err, "Échec du changement d'organisation");
        return false;
      } finally {
        this.loading = false;
      }
    },

    logout() {
      AuthHelper.logout();
      this.accessType = "U";
      this.superAdmin = false;
      this.activeOrganization = null;
      this.availableOrganizations = [];
    },

    handleError(error, defaultMessage = "Une erreur est survenue") {
      console.error("Erreur API:", error);

      let title = "Erreur";
      let message = defaultMessage;
      let html = "";

      if (error?.response) {
        const { status, data } = error.response;

        if (status === 400) title = "Requête invalide";
        else if (status === 401) title = "Non autorisé";
        else if (status === 403) title = "Accès refusé";
        else if (status === 404) title = "Ressource introuvable";
        else if (status >= 500) title = "Erreur serveur";

        if (typeof data?.message === "string") message = data.message;

        if (data?.errors && typeof data.errors === "object") {
          const fields = Object.entries(data.errors)
            .map(([k, v]) => `<div><strong>${k}</strong> : ${Array.isArray(v) ? v.join("<br>") : v}</div>`)
            .join("");
          html = `<div style="text-align:left; margin-top:10px;">${fields}</div>`;
        }
      }

      if (!html && error?.message) {
        html = `<div style="text-align:left;">${error.message}</div>`;
      }

      Swal.fire({
        title,
        html: `<p>${message}</p>${html}`,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
        timer: html ? undefined : 6000,
        timerProgressBar: true,
      });
    },
  },
});
